import * as moment from 'moment';
import { Moment } from 'moment';
import { IOtherField } from '../../interfaces/other-field.interface';

export interface IJobExperience {
  _id?: string;
  category?: string;
  charter?: string;
  city?: string;
  company_name?: string;
  country?: string;
  date_end?: Moment;
  date_start?: Moment;
  currently?: boolean;
  section?: string;
  job?: IOtherField;
  position?: IOtherField;
  position_category?: IOtherField;
  recruiting_agency?: string;
  subcharter?: string;
  description?: string;
  vessel_type?: string;
}

export class JobExperience {
  _id?: string;
  charter: string;
  city: string;
  company_name: string;
  country: string;
  date_end: Moment;
  date_start: Moment;
  currently: boolean;
  job: IOtherField;
  position: IOtherField;
  position_category: IOtherField;
  recruiting_agency: string;
  subcharter: string;
  section: string;
  description: string;
  vessel_type: string;

  constructor( data: IJobExperience = {} ) {
    this._id = data._id;
    this.currently = data.currently || false;
    this.charter = data.charter;
    this.city = data.city;
    this.company_name = data.company_name;
    this.country = data.country;
    this.date_end = data.date_end ? moment(data.date_end) : null;
    this.date_start = data.date_start ? moment(data.date_start) : null;
    this.job = data.job || { value: undefined };
    this.position = data.position || { value: undefined };
    this.position_category = data.position_category || {};
    this.recruiting_agency = data.recruiting_agency;
    this.subcharter = data.subcharter;
    this.description = data.description;
    this.section = data.section;
    this.vessel_type = data.vessel_type;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/job-experience.ts